import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";

import {
  ModalRenameDrsFile,
  ModalRenameDrsFileProps,
} from "components/ModalRenameDrsFile/ModalRenameDrsFile";
import { useState } from "react";
import { getDrsFileModifyPermissionByDrsFileAndAction } from "types/DrsFileModifyPermissions";

export interface ButtonRenameDrsFileProps {
  drsFile: Parameters<typeof getDrsFileModifyPermissionByDrsFileAndAction>[0] &
    ModalRenameDrsFileProps["drsFile"];
}

export const ButtonRenameDrsFile = ({ drsFile }: ButtonRenameDrsFileProps) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  return (
    <>
      <ButtonIconPermissioned
        aria-label="Rename file"
        defaultTooltip={"Rename file"}
        color="primary"
        iconType="pencil"
        disabled={
          !getDrsFileModifyPermissionByDrsFileAndAction(drsFile, "RENAME")
            .isPermitted
        }
        onClick={() => {
          setShowConfirmModal(true);
        }}
        requiredPermission="edit"
      />
      {showConfirmModal && (
        <ModalRenameDrsFile
          drsFile={drsFile}
          onClose={() => setShowConfirmModal(false)}
        />
      )}
    </>
  );
};
